(function () {
  // csak mobilon fusson
  if (window.matchMedia && window.matchMedia("(min-width: 769px)").matches) return;

  function handleTap(e) {
    var t = e.target;
    if (!t) return;

    // linkre ne nyúljunk (ÁSZF link működjön)
    if (t.closest && t.closest("a")) return;

    // csak akkor dolgozzunk, ha LABEL-en belül kattintott/tapelt
    var label = t.closest ? t.closest("label") : null;
    if (!label) return;

    var cb = label.querySelector('input[type="checkbox"]');
    if (!cb) return;

    // ha magára a checkboxra tapelt, engedjük a natív működést
    if (t === cb) return;

    // iPhone-on ez szünteti meg a "dupla tap" jelenséget
    e.preventDefault();
    cb.checked = !cb.checked;
    cb.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // iPhone/Safari: touchend kell, nem click
  document.addEventListener("touchend", handleTap, { capture: true, passive: false });
})();

/* === FIX: Cart drawer T&C checkbox single tap on mobile === */
(function () {
  if (!window.matchMedia || !window.matchMedia("(max-width: 768px)").matches) return;

  document.addEventListener(
    "touchend",
    function (e) {
      // csak a jobb oldali felugró kosárban (drawer)
      var drawer = e.target.closest("#ltn_utilize-cart-menu, .ltn__utilize-cart-menu");
      if (!drawer) return;

      // linkre kattintás maradjon link
      if (e.target.closest("a")) return;

      // csak a checkbox blokkon belül reagáljunk
      var wrap = e.target.closest(".checkbox-wrapper-46, .jscheckbox, .popup-terms");
      if (!wrap) return;

      var cb = wrap.querySelector('input[type="checkbox"]');
      if (!cb) return;

      // ha a checkbox környékére tapol (label / svg / span), akkor egyből toggle
      if (!e.target.closest("label, span, svg")) return;

      e.preventDefault();
      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
    },
    { passive: false }
  );
})();